export default "__VITE_ASSET__2ub_RVek__"